import React, { useMemo } from 'react';
import IconRow from './IconRow';
import { ReactComponent as Pay } from 'assets/icons/appointmentsIcons/dollar.svg';
import { ReactComponent as Reason } from 'assets/icons/appointmentsIcons/reason-goal.svg';
import { AppointmentPayment } from '../../../dashboard/components/upcomingAppointments/interfaces/upcomingAppointments.interfaces';
import { AppointmentHasuraStatus } from '../../const/appointment';
import moment from 'moment/moment';
import { useAuth } from 'auth/context/AuthContext';
import { Roles } from '../../../../firebase/interfaces';
import { formatPrice } from 'utilities/priceHelpers';

interface IReasonAndPaymentBlockProps {
  subjectOfAppointment?: string;
  appointmentId: string;
  paymentInformation?: AppointmentPayment;
  appointmentStatus?: AppointmentHasuraStatus;
  showPrice?: boolean;
  startAt?: string;
}

const STATUS_PAYMENT = [AppointmentHasuraStatus.Booked];

export const showTooltipMinChars = 30;

const ReasonAndPaymentBlock: React.FC<IReasonAndPaymentBlockProps> = ({
  subjectOfAppointment,
  appointmentId,
  paymentInformation,
  startAt,
  showPrice = false,
  appointmentStatus,
}) => {
  const isPaymentStatus = STATUS_PAYMENT.includes(
    appointmentStatus as AppointmentHasuraStatus,
  );

  const { user } = useAuth();

  const isProvider = useMemo(() => user?.role === Roles.PROVIDER, [user]);

  const discountValue = useMemo(() => {
    const { amountOff, percentOff } = paymentInformation?.discount ?? {};
    return (
      (amountOff ?? 0) / 100 ||
      ((Number(paymentInformation?.amount) || 0) * (percentOff || 0)) / 100
    );
  }, [paymentInformation]);

  const isShowPayment = !isProvider || showPrice;

  const lastPayTime = moment(startAt).format('MM/DD/YYYY');

  return (
    <div className="flex flex-col justify-center gap-2.5 w-full">
      <IconRow
        icon={<Reason className="min-w-[1.25rem]" />}
        tooltipId={appointmentId}
        text={subjectOfAppointment}
        showTooltip={(subjectOfAppointment?.length || 0) >= showTooltipMinChars}
      />
      <div className={isShowPayment ? 'opacity-100' : 'opacity-0'}>
        <IconRow
          showTooltip={false}
          icon={<Pay className="fill-neutral-800 min-w-[1.25rem]" />}
          text={
            isPaymentStatus ? (
              discountValue ? (
                <p>
                  Paid (
                  <span className="text-med-gray-3 opacity-50 line-through">
                    ${paymentInformation?.amount || 0}
                  </span>{' '}
                  <span className="text-bright-green">
                    {formatPrice(
                      (
                        (paymentInformation?.amount || 0) - discountValue
                      ).toString(),
                    )}
                  </span>
                  )
                </p>
              ) : (
                `Paid ($${paymentInformation?.amount || 0})`
              )
            ) : (
              `Payment will be charged on ${lastPayTime}`
            )
          }
        />
      </div>
    </div>
  );
};

export default ReasonAndPaymentBlock;
